<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5" v-if="form != null">
          <section>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Product Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="pro_name"
                  class="w-full"
                  v-model="form.pro_name"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('pro_name')"
                  >{{ errors.first("pro_name") }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Short Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  rows="5"
                  name="pro_shortdesc"
                  class="w-full"
                  v-model="form.pro_shortdesc"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('pro_shortdesc')"
                  >{{ errors.first("pro_shortdesc") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Long Description</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea
                  rows="5"
                  name="pro_longdesc"
                  class="w-full"
                  v-model="form.pro_longdesc"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('pro_longdesc')"
                  >{{ errors.first("pro_longdesc") }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Weight</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  name="websweightite"
                  class="w-full"
                  v-model="form.weight"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('weight')"
                  >{{ errors.first("weight") }}</span
                >
              </div>
            </div>
          </section>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Update</vs-button
              >
            </div>
          </div>
        </vs-card>
        <vs-card class="px-5 py-5">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Image</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <img :src="form.image" style="width: 120px" class="mb-5" />
              <vs-input
                type="file"
                ref="image"
                name="image"
                class="w-full"
                v-model="form.image"
                @change="setImg"
              />
              <span class="text-danger text-sm" v-show="errors.has('image')">{{
                errors.first("image")
              }}</span>
            </div>
          </div>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" @click.prevent="doUploadFile"
                >Upload</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";
export default {
  components: {},
  props: ["id"],
  data: () => ({
    suffixParams: "",
    valid: true,
    form: {
      image: "",
    },
    filterList: [],
    file: {
      image: null,
    },
  }),
  created() {
    setTimeout(() => {
      this.suffixParams =
        "?s=" + this.$route.query.s + "&e=" + this.$route.query.e;
      Service.LiveProduct.get(this.id, this.$route.query.e).then((res) => {
        this.form = res.data.product;
      });
    }, 1000);
  },
  methods: {
    loadFilter() {
      let filterData = {
        e: this.$route.query.e,
        m: "product",
        currentPage: 1,
        perPage: 50,
      };

      let params = Object.keys(filterData)
        .map((key) => key + "=" + filterData[key])
        .join("&");

      Service.Filter.gets(params).then((res) => {
        this.filterList = res.data.rows;
      });
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        ...this.form,
      };

      this.$vs.loading();
      Service.Speaker.update(data).then((res) => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          this.$router.push(
            "/conferences/speakers?s=" +
              this.$route.query.s +
              "&e=" +
              this.$route.query.e
          );
        }
        this.$vs.loading.close();
      });
    },
    setImg(e) {
      this.file.image = e.target.files[0];
    },
    doUploadFile() {
      this.$vs.loading();
      var formData = new FormData();

      formData.append("e", this.$route.query.e);

      if (this.file.image != null) {
        formData.append("image", this.file.image);
      }

      Service.LiveProduct.upload(this.id, formData).then((res) => {
        if (res.success) {
          Service.LiveProduct.get(this.id, this.$route.query.e).then((res) => {
            this.form = res.data.product;
          });

          this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success",
          });
          //window.location.href = "/conferences/speakers" + this.suffixParams;
        }
      });
    },
  },
};
</script>